import React from "react";
import styles from "./GiveawayItem.module.css";
import clock from "/clockicon.svg";
import calendar from "/calendar.svg";
import dreamcoinLogo from "/DC_coin.svg";
import CharacterLogo from "/character-circle-gold.svg";
import telegramNFTLogo from "/telegramNFT.svg";
import { TimeDisplay } from "../../../../../utils/TimeDisplay";
import couponLogo from "/couponLogo.svg";

interface MainPrize {
  amount: number;
  type: string;
  item_type: string;
}

interface GiveawayItemProps {
  giveaway: {
    background: string;
    end_date: string;
    id: number;
    main_prizes: MainPrize[];
    status: string;
    coupons_purchased_dc: number;
    coupons_purchased_stars: number;
  };
  isArchive?: boolean;
  onGiveawayClick: (id: number) => void;
}

const formatNumber = (num: number): string => {
  return num.toLocaleString("en-US");
};

export const GiveawayItem: React.FC<GiveawayItemProps> = ({
  giveaway,
  isArchive,
  onGiveawayClick,
}) => {
  return (
    <div
      className={styles.giveawayItem}
      onClick={() => onGiveawayClick(giveaway.id)}
    >
      <img src={giveaway.background} alt="Giveaway" />
      <div className={styles.timeLeft}>
        <div className={styles.timeIconSpan}>
          <img
            src={isArchive ? calendar : clock}
            alt="time"
            className={isArchive ? styles.calendarIcon : styles.timeIcon}
          />
        </div>
        <div className={styles.timeLeftText}>
          {giveaway.status === "winner_selection" ? (
            "Выбор победителя..."
          ) : (
            <>
              <TimeDisplay endDate={giveaway.end_date} format="short" />
            </>
          )}
        </div>
      </div>

      <div className={styles.infoOverlay}>
        <div
          className={`${styles.prizes} ${
            giveaway.main_prizes.length === 1 ? styles.singlePrize : ""
          }`}
        >
          {giveaway.main_prizes.map((item, index) => (
            <div className={styles.prizeItem} key={index}>
              {item.type === "Character" ? (
                <></>
              ) : item.type === "TelegramNFT" ? (
                <></>
              ) : (
                <div className={styles.prizeAmount}>
                  {formatNumber(item.amount)}
                </div>
              )}
              <div className={styles.prizeType}>
                {item.type === "Character"
                  ? "Легендарный"
                  : item.type === "TelegramNFT"
                  ? "Подарки"
                  : item.type}
              </div>
              <div className={styles.prizeIcon}>
                {item.type === "DC" ? (
                  <img src={dreamcoinLogo} alt="DC" />
                ) : item.type === "TelegramNFT" ? (
                  <img
                    src={telegramNFTLogo}
                    alt="TelegramNFT"
                    style={{ width: "16px", height: "16px" }}
                  />
                ) : (
                  <img src={CharacterLogo} alt="Character" />
                )}
              </div>
            </div>
          ))}
        </div>
        <div className={styles.giveawayBtnDiv}>
          <button
            className={
              isArchive ? styles.giveawayBtnArchive : styles.giveawayBtn
            }
          >
            {isArchive ? (
              "Результаты"
            ) : giveaway.status === "winner_selection" ? (
              "Смотреть трансляцию"
            ) : giveaway.coupons_purchased_stars +
                giveaway.coupons_purchased_dc ===
              0 ? (
              "Участвовать"
            ) : (
              <div className={styles.buttonInnerDiv}>
                <div className={styles.buttonInnerDivTextSmall}>
                  Участвуешь с{" "}
                  {giveaway.coupons_purchased_stars +
                    giveaway.coupons_purchased_dc}
                </div>
                <img
                  src={couponLogo}
                  alt="Coupon"
                  className={styles.buttonInnerDivIcon}
                />
              </div>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};
